class Toast {
    static show(message, type = 'info', duration = 5000) {
        const toast = document.createElement('div');

        // Base style
        toast.className = `toast-enter flex items-center justify-between p-4 rounded-lg shadow-md max-w-sm w-full border`;

        // Type-specific styles
        let icon = "info-circle-fill";
        let wrapperClasses = "bg-blue-50 border-blue-500 text-blue-600";
        let iconClasses = "bg-blue-500 text-white";

        if (type === "success") {
            icon = "check-circle-fill";
            wrapperClasses = "bg-green-50 border-green-500 text-green-600";
            iconClasses = "bg-green-600 text-white";
        }
        if (type === "error") {
            icon = "x-circle-fill";
            wrapperClasses = "bg-red-50 border-red-500 text-red-600";
            iconClasses = "bg-red-500 text-white";
        }
        if (type === "warning") {
            icon = "exclamation-triangle-fill";
            wrapperClasses = "bg-yellow-50 border-yellow-500 text-yellow-600";
            iconClasses = "bg-yellow-500 text-white";
        }

        toast.classList.add(...wrapperClasses.split(" "));

        toast.innerHTML = `
            <!-- Icon -->
            <div class="flex items-center gap-3">
                <div class="flex items-center justify-center w-8 h-8 rounded-full ${iconClasses}">
                    <i class="bi bi-${icon} text-md"></i>
                </div>
                <p class="text-sm font-medium">${message}</p>
            </div>

            <!-- Close -->
            <button class="ml-4 text-slate-500 hover:text-slate-700">
                <i class="bi bi-x"></i>
            </button>
        `;

        const container = document.getElementById("toastContainer");
        container.appendChild(toast);

        toast.querySelector("button").addEventListener("click", () => {
            Toast.remove(toast);
        });

        if (duration > 0) {
            setTimeout(() => {
                Toast.remove(toast);
            }, duration);
        }

        return toast;
    }

    static remove(toast) {
        toast.classList.remove("toast-enter");
        toast.classList.add("toast-exit");

        setTimeout(() => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
        }, 300);
    }
}
